import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: '111', label: 'New Zealand European/Pākehā' },
    { value: '121', label: 'British / Irish' },
    { value: '122', label: 'Dutch' },
    { value: '123', label: 'Greek' },
    { value: '124', label: 'Polish' },
    { value: '125', label: 'South Slav' },
    { value: '126', label: 'Italian' },
    { value: '127', label: 'German' },
    { value: '128', label: 'Australian' },
    { value: '129', label: 'Other European' },
    { value: '211', label: 'Māori' },
    { value: '311', label: 'Samoan' },
    { value: '321', label: 'Cook Islands Māori' },
    { value: '331', label: 'Tongan' },
    { value: '341', label: 'Niuean' },
    { value: '351', label: 'Tokelauan' },
    { value: '361', label: 'Fijian' },
    { value: '371', label: 'Other Pacific Peoples' },
    { value: '411', label: 'Filipino' },
    { value: '412', label: 'Cambodian' },
    { value: '413', label: 'Vietnamese' },
    { value: '414', label: 'Other Southeast Asian' },
    { value: '421', label: 'Chinese' },
    { value: '431', label: 'Indian' },
    { value: '441', label: 'Sri Lankan' },
    { value: '442', label: 'Japanese' },
    { value: '443', label: 'Korean' },
    { value: '444', label: 'Other Asian' },
    { value: '511', label: 'Middle Eastern' },
    { value: '521', label: 'Latin American' },
    { value: '531', label: 'African' },
    { value: '611', label: 'Other Ethnicity' },
    { value: '999', label: 'Not Stated' },
  ],
});
